export type Route = {
  id: number;
  number: string;
  nameHy: string;
  nameEn: string;
  nameRu: string;
  stationFromId: number;
  stationToId: number;
};

export type TrainType = {
  id: number;
  nameHy: string;
  nameEn: string;
  nameRu: string;
};
export type TTrip = {
  id: number;
  route: Route;
  trainType: TrainType;
  startTime: string;
  finishTime: string;
  salesStartDelay: number;
  salesStopDelay: number;
  refundStopDelay: number;
  wagonCount: number;
  seatCount: number;
  soldSeatCount: number;
  seatTicketSupported: boolean;
  blocked: boolean;
  wagons: TWagon[];
};

export const enum ESeatType {
  normal = 0,
  accessible = 1,
}
export const enum ESeatStatus {
  free = 0,
  sold = 1,
  booked = 2,
}

// 1 - на вокзальной кассе, 2 - через web, 3 - админом
export const enum ESeatBookingType {
  office = 1,
  web = 2,
  admin = 3,
}

export type TWagonSeat = {
  tripId: number;
  wagonNum: number;
  seatNum: number;
  type: ESeatType;
  bookingType?: ESeatBookingType;
  status: ESeatStatus;
  orderId?: number | null;
  bookingExpDate?: string | null;
  extraDataAttrs?: Record<string, string | number | boolean | undefined | null>;
};
export type TWagon = {
  number: number;
  typeId: number;
  direction: null | 'forward' | 'backward';
  seats: TWagonSeat[];
};

export type NewBookSeat = {
  payReturnUrl: string;
  payType: 1;
  tripId: number;
  stationToId: number;
  stationFromId: number;
  tickets: {
    seatNum?: number;
    wagonNum?: number;
    tariffId: number;
  }[];
};
